/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Allocationamounttoolarge5Inputs */

const en_coinvestments_declinedeal_reasons_allocationamounttoolarge5 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Allocationamounttoolarge5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation amount too large`)
};

/**
* | output |
* | --- |
* | "Allocation amount too large" |
*
* @param {Coinvestments_Declinedeal_Reasons_Allocationamounttoolarge5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_allocationamounttoolarge5 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Allocationamounttoolarge5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Allocationamounttoolarge5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_allocationamounttoolarge5(inputs)
});
export { coinvestments_declinedeal_reasons_allocationamounttoolarge5 as "coInvestments_declineDeal_reasons_allocationAmountTooLarge" }